import StatusNotification from '../editor/ui/top-submenu/status';

// Persist these across instances
let totalNumSteps = 0;
let totalCurrStep = 0;
let isLast = false;

function displayProgress (name, handleDisplay, currStep, numSteps) {
  INKIVE.C.DEBUG && console.log(
    `[${name} progress]: ${format(currStep, numSteps)}`, { currStep, numSteps },
    `\n[Total progress]: ${format(totalCurrStep, totalNumSteps)}`, { totalCurrStep, totalNumSteps }
  );

  const formattedTotalProgress = format(currStep, numSteps);
  const preparingTxt = INKIVE.TranslateHelper.translate('top_submenu.download_modal.status_notification_preparing');
  handleDisplay && StatusNotification.display(`${preparingTxt} ${formattedTotalProgress}`, null, true);
  return formattedTotalProgress;
}

function format (a, b) {
  let percentString;
  if (b === 0) {
    percentString = isLast ? '100%' : '0%';
  } else {
    percentString = `${Math.round(a / b * 100)}%`;
  }
  return percentString;
}

function getTimeStamp () {
  const now = new Date();
  return now.getTime();
}

export default class ProgressNotification {
  constructor (name, handleDisplay = false, currStep = 0, numSteps = 0) {
    this.name = name;
    this.localCurrStep = currStep;
    this.localNumSteps = numSteps;
    this.handleDisplay = handleDisplay;
  }

  get numSteps () {
    return this.localNumSteps;
  }

  set numSteps (value) {
    this.localNumSteps = value;
    totalNumSteps += value;
  }

  first () {
    isLast = false;
    this.startTime = getTimeStamp();

    return displayProgress(this.name, this.handleDisplay, 0, 0);
  }

  last () {
    if (totalCurrStep === totalNumSteps) {
      totalCurrStep = 0;
      totalNumSteps = 0;
      isLast = true;
    }
    this.localCurrStep = 0;
    this.endTime = getTimeStamp();
    INKIVE.C.DEBUG && console.log(`[${this.name} duration]:`, this.endTime - this.startTime, 'ms');
    displayProgress(this.name, this.handleDisplay, 1, 1);
    return isLast;
  }

  next () {
    this.localCurrStep += 1;
    totalCurrStep += 1;
    isLast = false;

    return displayProgress(this.name, this.handleDisplay, this.localCurrStep, this.localNumSteps);
  }
}
